<template>
  <div class="row">

    <div class="col-7 progress_bar_sec">
      <div class="row">
        <div class="col-12 progress-row">
          <div class="progress-bar-label">{{completeCount+inProgressCount}} of {{totalCount}}</div>
          <b-progress :max="totalCount">
            <b-progress-bar :value="completeCount" class="prog_bar__completed"></b-progress-bar>
            <b-progress-bar :value="inProgressCount" class="prog_bar__in_progress"></b-progress-bar>
          </b-progress>
        </div>
      </div>
    </div>
    <div class="col-1 pl-0 pr-0"></div>
    <div class="col-4 score_sec pl-0">
      <div class="row">
        <div class="col-6 score_label">
          <span class="score_lebel ml-0">score</span>
        </div>
        <div class="col-6 score_box">
          <span class="progress_block float-left ml-0" style="height: 32px; width: 70px;">
            <span class="state" :class="statusClass(performance, hideScoreForStudent)" style="height: 32px; width: 70px;">
              <span v-if="hideScoreForStudent || !performance" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
              <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;">{{performance.toFixed(2)}}%</span>
            </span>
          </span>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
  import { mapState,mapActions } from 'vuex'

  export default {
    name: 'program-category-score-and-progress-bar',
    props: ['performance', 'hideScoreForStudent', 'completeCount','totalCount', 'inProgressCount'],
    data: () => {
      return {
        isScoreNotAvailable: true,
        courseDetail: {}
      }
    },
    mounted () {
    },
    methods: {
      ...mapActions([
        'loadCourseDetailFromServerWithoutStoringInState'
      ]),
      statusClass (performance, hideScoreForStudent) {
        if (performance && !this.isScoreNotAvailable && !hideScoreForStudent) {
          if (performance >= 90) {
            return 'gradeA'
          } else if (performance >= 80 && performance < 90) {
            return 'gradeB'
          } else if (performance >= 65 && performance < 80) {
            return 'gradeC'
          } else if (performance >= 40 && performance < 65) {
            return 'gradeD'
          } else if (performance < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramCategoryScoreAndProgressBar.vue